import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
  Space
} from '@lockerpm/design';

import {
  SearchOutlined,
  MenuOutlined,
  GiftOutlined,
  StarOutlined
} from '@ant-design/icons';

import itemsComponents from '../../components/items';
import layoutComponents from '../../components/layout';

import global from '../../config/global';
import common from '../../utils/common';

import '../../web-sh/src/layouts/css/header.scss';

function Header(props) {
  const { t } = useTranslation()
  const { ImageIcon } = itemsComponents;
  const { Breadcrumb, SearchContent, Notifications, DropdownMenu, SwitchProject } = layoutComponents;
  const { collapsed, setCollapsed, setRespCollapsed } = props;

  const isMobile = useSelector((state) => state.system.isMobile);
  const plan = useSelector((state) => state.payment.plan);
  const userInfo = useSelector(state => state.auth.userInfo);

  const [search, setSearch] = useState(false);

  document.addEventListener('click', (e) => {
    const searchContent = document.getElementById('search-content');
    const btnSearchContent = document.getElementById('btn-search-content');
    if (searchContent && !searchContent.contains(e.target) && btnSearchContent && !btnSearchContent.contains(e.target)) {
      setSearch(false)
    }
  })

  const shouldShowRewardsAndPlans = useMemo(() => {
    return common.isPersonalUser() && !common.isLifeTimeUser() && !common.isFamilyUser();
  }, [plan, userInfo]);

  return (
    <div className={`${props.className} ${isMobile  ? 'mobile' : ''}`}>
      <div className='admin-layout-header__left flex items-center'>
        {
          isMobile && <div className='menu-toggle-icon' onClick={() => setRespCollapsed(false)}>
            <MenuOutlined style={{ fontSize: 20 }}/>
          </div>
        }
        {
          !isMobile && <div className='menu-toggle-icon mr-2' onClick={() => setCollapsed(!collapsed)}>
            <ImageIcon
              name={ collapsed ? 'expand-icon' : 'wrapper-icon' }
              className={'flex items-center'}
            />
          </div>
        }
        {
          !isMobile && <Breadcrumb />
        }
      </div>
      <div className='admin-layout-header__right flex items-center'>
        <Space size={[8, 8]}>
          {
            shouldShowRewardsAndPlans && <Button
              id="btn-rewards"
              type="primary"
              ghost
              shape={isMobile ? "circle" : "round"}
              icon={<GiftOutlined />}
              onClick={() => global.navigate(global.keys.REWARDS)}
            >
              {isMobile ? '' : t('sidebar.rewards')}
            </Button>
          }
          {
            shouldShowRewardsAndPlans && <Button
              id="btn-manage-plans"
              type="primary"
              shape={isMobile ? "circle" : "round"}
              icon={<StarOutlined />}
              onClick={() => common.clickBuyPremium()}
            >
              {isMobile ? '' : t('manage_plans.title')}
            </Button>
          }
          <Button
            id="btn-search-content"
            shape="circle"
            disabled={search}
            icon={<SearchOutlined />}
            onClick={() => setSearch(true)}
          />
          <Notifications />
          <SwitchProject />
          {
            isMobile && <DropdownMenu />
          }
        </Space>
      </div>
      {
        search && <SearchContent
          className='admin-layout-header__search-content'
          onClose={() => setSearch(false)}
        />
      }
    </div>
  );
}

export default Header;
